import { memo, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
// Local files
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSuccess from 'hooks/useSuccess';
import useInvitations from 'hooks/useInvitations';
import { checkValidEmail } from 'helpers';
import { invitationsSelectors } from 'features/invitations';

const Invitation = ({ open, onClose }) => {
  const { setSuccess } = useSuccess();
  const { createInvitation } = useInvitations();
  const fetching = useCustomSelector(invitationsSelectors.invitationIsFetching);
  const [email, setEmail] = useState({ value: '', error: '' });

  const handleCreate = () => {
    let hasError = false;

    if (!checkValidEmail(email.value)) {
      setEmail(prev => ({ ...prev, error: `Email is invalid` }) );
      hasError = true;
    }
    if (hasError) return;

    const invitation = { email: email.value };

    createInvitation(invitation)
    .then(({ error }) => {
      if (!error) {
        setSuccess('Invitation successfully created');
        onClose();
      }
    })
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      otherPaperStyle={{ width: '100%', maxWidth: 500 }}
      title='Create Invitation'
      actions={
        <>
          <Button
            disabled={fetching}
            variant='outlined'
            color='error'
            onClick={handleCreate}
            sx={{ fontSize: '12px', px: '28px' }}
          >
            Create
          </Button>
        </>
      }
    >
      <Box sx={{ px: 4, pb: 3 }}>
        <TextField
          fullWidth
          margin='normal'
          label='Email'
          disabled={fetching}
          helperText={email.error}
          error={!!email.error}
          value={email.value}
          onChange={({ target: { value } }) => setEmail({ value, error: '' })}
        />
      </Box>
    </BaseDialog>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Invitation {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);